import { chevronForward, options, calculator, search, trash, arrowBackOutline, save} from 'ionicons/icons';

export const helpContent = () => {
  return { 
    descriptionScreen:"Esta pantalla permite modificar las cantidades físicas de los artículos vinculados a un inventario.", 
    butonGuide:[
      {
        icon: chevronForward,
        descriptionButon: " Toma Física - (Detalle): ",
        description: 'Al hacer clic en el botón, se cargará una lista con todos los artículos asociados a un inventario.'
      },
      {
        icon: options,
        descriptionButon: " Detalle Toma Física - (Filtros): ",
        description: 'Al hacer clic en el botón, se abrirá un modal que permitirá realizar una búsqueda personalizada utilizando los siguientes filtros: código, nombre, grupos de artículos, áreas, y una sección para el filtro de artículos con movimientos, sin movimientos o todos.'
      },
      {
        icon: search,
        descriptionButon: " Detalle Toma Física - (Buscar): ",
        description: 'Al hacer clic en el botón, se realizará una búsqueda de los artículos según los filtros ingresados previamente.'
      },
      {
        icon: trash,
        descriptionButon: " Detalle Toma Física - (Limpiar): ",
        description: 'Al dar clic en el botón, se limpiarán los filtros de búsqueda y se mostrará la lista de todos los artículos.'
      },
      {
        icon: calculator,
        descriptionButon: " Detalle Toma Física - (Calculadora): ",
        description: 'Al dar clic en el botón, se desplegará un modal el cual cuenta con una calculadora donde podremos realizar las operaciones aritméticas, tales como suma, resta, multiplicación y división.'
      },
      {
        icon: save,
        descriptionButon: " Detalle Toma Física - (Guardar): ",
        description: 'Al dar clic en el botón, se actualizarán las cantidades modificadas de los artículos de la toma física seleccionada.'
      }, {
        icon: arrowBackOutline,
        descriptionButon: "Detalle Toma Física - (volver): ",
        description: 'Al dar clic en el botón, se regresará a la pantalla en la cual se muestran todas las tomas físicas en estado pendiente.'
      }
    ], 
    userGuide:[
      {
        tittle: "Lista Toma Física",
        description: "Al ingresar al módulo de toma física, encontraremos una lista de los inventarios en estado pendiente para el restaurante seleccionado."
      },
      {
        tittle: "Detalle Toma Física",
        description: "Al ingresar a la pantalla encontraremos una lista detalla de todos los artículos asociados a un inventario, donde se encontrará el nombre, la unidad, el grupo y las áreas a las cuales pertenece cada artículo."
      },
      {
        tittle: "Buscar Artículos",
        description: "Existen dos formas de buscar un artículo. La primera consiste en escribir el nombre del artículo en la barra de búsqueda ubicada en la parte superior de la pantalla de detalle de la toma física. Esto filtrará la lista de artículos que se encuentran visibles en pantalla. La segunda opción es abrir el modal de filtros, donde se podrá personalizar la búsqueda de los artículos utilizando los siguientes criterios: código, nombre, grupo de artículo, área y una opción para seleccionar ítems con movimientos, sin movimientos o todos."
      },{
        tittle: "Actualizar Cantidad Física",
        description: "Para modificar la cantidad física de un artículo, es necesario introducir el valor que se desea en el campo correspondiente. Después de efectuar este ajuste, si se quiere almacenar la actualización, solo se debe hacer clic en el botón 'Guardar'. Si no se hace clic, hay dos formas diferentes para guardar las cantidades: primero, se efectúa la actualización automática tras pasar 2 minutos en la pantalla de los detalles de la toma física; segundo, se actualizarán automáticamente al volver a la pantalla principal del módulo de toma física."
      }
    ]
  };  
}

export const PhysicalTakeHeader = () => {
  return [
      {
          "text": "Tipo",
          "value": "typeTake"
      },
      {
          "text": "Fecha",
          "value": "date"
      },
      {
          "text": "Detalles",
          "value": "actions"
      }
  ];
}

export const PhysicalTakeHeader2 = () => {
  return [
      {
          "text": "Tipo",
          "value": "typeTake"
      },
      {
          "text": "Fecha",
          "value": "date"
      }
  ];
}

export const PhysicalTakeHeaderDetail = () => {
  return [
      {
          "text": "Area",
          "value": "areaName"
      },
      {
          "text": "Nombre",
          "value": "name"
      },
      {
          "text": "Código Artículo",
          "value": "articleCode"
      },
      {
        "text": "Unidad",
        "value": "unitInventory"
      },
      {
          "text": "Grupo",
          "value": "articleGroup"
      }
      ,
      {
          "text": "Cantidad Física",
          "value": "actions"
      }
      
  ];
}